import moment from 'moment';

export default ngModule => {

  /**
   **/
  ngModule.directive('aonDate', (AonConfig) => {
    return {
      restrict: 'A',
      require: 'ngModel',
      replace: true,
      scope: {
        'model': '=ngModel',
        'futureOnly': '=',
        'noDays': '=',
        'minAge': '@',
        'maxAge': '@',
        'underThirty': '@',
        'allowEmpty': '=',
        'allowFuture': '=',
        'minDate': '=',
      },
      template: require("./date.html"),
      link: (scope, element, attrs, ngModel) => {
        const noDays = scope.noDays;
        const is_required = scope.allowEmpty !== true;

        let minAge = 0;
        if (scope.overEighteen && scope.overEighteen !== 'false') {
          minAge = 18;
        } else if (scope.minAge) {
          minAge = Number(scope.minAge);
        }

        // Set max age, transform the value to a number
        let maxAge = 0;
        if (scope.maxAge) {
          maxAge = Number(scope.maxAge);
        }

        const splitDate = modelValue => {
          let [year, month, day] = (modelValue || "").split('-');
          if (noDays) day = 1;
          return {
            day: parseInt(day),
            month: parseInt(month),
            year: parseInt(year)
          };
        };

        const formatValue = modelValue => {
          const date = splitDate(modelValue);
          const isValid = validateDate(date);
          if (!isValid && is_required) {
            if (isUnderAge(date)) {
              ngModel.$setValidity('underage', false);
            } else {
              ngModel.$setValidity('date', isValid);
            }
            if (isOverAge(date)) {
              ngModel.$setValidity('overage', false);
            } else {
              ngModel.$setValidity('date', isValid);
            }
          }
          return date;
        };

        scope.formChoices = AonConfig.formChoices;
        scope.$watch('model', value => {
          if (value) {
            let [year, month, day] = scope.model.split("-");
            scope.day = parseInt(day);
            scope.month = parseInt(month);
            scope.year = parseInt(year);

            // This is to support programmatic updates to the model value that are likely
            // already valid (e.g. driven by a pre-fill from another field). This will
            // make sure angular things the field is valid, if the value is a valid date.
            if (validateDate(splitDate(value))) {
              scope.onDateChange();
            }
          }
        });

        let yearsChoices = AonConfig.formChoices.date[scope.futureOnly ? 'future_years' : 'years'];
        if (!scope.futureOnly && scope.allowFuture) {
          yearsChoices = yearsChoices.concat(AonConfig.formChoices.date['future_years']);
        }
        const sortedYears = yearsChoices.slice().sort();

        scope.yearsChoices = yearsChoices;

        const isUnderAge = (viewValue) => {
          if (minAge <= 0) {
            return false;
          }

          const dob = moment();
          dob.set('year', viewValue.year);
          dob.set('month', viewValue.month - 1);
          dob.set('date', viewValue.day);
          const age = moment().diff(dob, 'years', false);
          return age < minAge;
        };

        const isOverAge = (viewValue) => {

          if (maxAge <= 0) {
            return false
          }

          const dob = moment();
          dob.set('year', viewValue.year);
          dob.set('month', viewValue.month - 1);
          dob.set('date', viewValue.day);
          const age = moment().diff(dob, 'years', false);
          return age > maxAge;
        }

        const zeroTime = (date) => {
          date.setHours(0);
          date.setMinutes(0);
          date.setSeconds(0);
          date.setMilliseconds(0);
          return date;
        };

        const isFuture = (viewValue) => {
          let now = zeroTime(new Date());
          let val = new Date(viewValue.year, viewValue.month - 1, viewValue.day);
          if (scope.noDays) {
            now.setDate(1);
            val.setDate(1);
          }
          return val >= now;
        };

        const isGreaterThanOrEqualToMinDate = (viewValue) => {
          const viewDate = zeroTime(new Date(viewValue.year, viewValue.month - 1, viewValue.day));
          const minDate = zeroTime(scope.minDate);
          return viewDate >= minDate;
        };

        const validateDate = (viewValue) => {
          const isValidDay = scope.noDays ? true : _.isNumber(viewValue.day) && viewValue.day >= 1 && viewValue.day <= 31,
                isValidMonth = _.isNumber(viewValue.month) && viewValue.month >= 1 && viewValue.month <= 12,
                isValidYear = _.isNumber(viewValue.year) && viewValue.year >= _.first(sortedYears)
                                && viewValue.year <= _.last(sortedYears);
          let valid = isValidDay && isValidMonth && isValidYear && !isUnderAge(viewValue) && !isOverAge(viewValue);
          let reassertDate = new Date(viewValue.year, viewValue.month - 1, viewValue.day);
          if (valid) {
              valid = (reassertDate.getFullYear() == viewValue.year
                  && reassertDate.getMonth() == viewValue.month - 1
                  && reassertDate.getDate() == viewValue.day
              );
          }

          if (valid && scope.minDate && !isGreaterThanOrEqualToMinDate(viewValue)) {
            return false;
          }

          return scope.futureOnly ? (valid && isFuture(viewValue)) : valid;
        };
        //ngModel.$validators = ngModel.$validators || {};
        //ngModel.$validators.date = validateDate;

        ngModel.$formatters.push(formatValue);

        /**
         * Including this cause angular-auto-validate to run *extremely* slow. No idea what's going on - I expect
         * a cascade of calls and digests. Workaround is the scope.$watch ('model'...) above
        ngModel.$render = () => {
          let {day, month, year} = ngModel.$viewValue;
          scope.day = parseInt(day);
          scope.month = parseInt(month);
          scope.year = parseInt(year);
          //scope.dateParts = {day, month, year};
        };*/

        ngModel.$parsers.push(viewValue => {
          // If any part of the date is filled, the whole date must be valid
          const hasValue = v => (typeof v !== 'undefined') && (v.length > 0 || typeof v === 'number');
          const must_be_valid = hasValue(viewValue.day) || hasValue(viewValue.month) || hasValue(viewValue.year);
          let digitsOnlyRegex = /^[0-9]*$/;
          if (scope.noDays) {
            viewValue.day = 1;
          } else {
            viewValue.day = digitsOnlyRegex.test(viewValue.day)
              ? parseInt(viewValue.day)
              : NaN;
          }
          viewValue.month = digitsOnlyRegex.test(viewValue.month)
            ? parseInt(viewValue.month)
            : NaN ;
          viewValue.year = digitsOnlyRegex.test(viewValue.year)
            ? parseInt(viewValue.year)
            : NaN;
          const isValid = validateDate(viewValue);

          if (!is_required && !must_be_valid) {
            ngModel.$setValidity('date', true);
            ngModel.$setValidity('underage', true);
            ngModel.$setValidity('overage', true);
          }

          if (is_required || must_be_valid) {
            ngModel.$setValidity('date', isValid);
            ngModel.$setValidity('underage', !isUnderAge(viewValue));
            ngModel.$setValidity('overage', !isOverAge(viewValue));
            if (!isValid && isUnderAge(viewValue)) {
              ngModel.$setValidity('date', true);
            }
            if (!isValid && isOverAge(viewValue)) {
              ngModel.$setValidity('date', true);
            }
          }

          return isValid ? `${viewValue.year}-${viewValue.month}-${viewValue.day}` : undefined;
        });

        scope.onDateChange =  () => {
          let {day, month, year} = scope;
          ngModel.$setViewValue({day, month, year});
          if (day && month && year) {
            // Trigger blur so we can do things like validate on blur, eg.
            // <div aon-date ng-model="model.dob" ng-model-options="{updateOn: 'blur'}">
            element.trigger('blur');
          }
        };
      }
    }
  });


}



// WEBPACK FOOTER //
// ./src/directives/date.js